import { useTranslation } from "react-i18next"
import { Link } from "react-router"
import { buildBetterDocSessionLink } from "@/modules/admin/better-doc/lib/build-better-doc-session-link"

type BetterDocSessionLinkProps = {
  sessionId: number
  onNavigate?: () => void
}

export const BetterDocSessionLink = ({ sessionId, onNavigate }: BetterDocSessionLinkProps) => {
  const { t } = useTranslation()

  return (
    <Link
      to={buildBetterDocSessionLink(sessionId)}
      onClick={onNavigate}
      className="text-primary hover:underline"
      data-testid={`better-doc-admin-session-link-${sessionId}`}>
      {t("admin.betterDoc.sessionLink", { sessionId })}
    </Link>
  )
}
